import { PARKING_TRANSFER_TYPE } from "@mozioinc/query";
import { ReactComponent as BusSvg } from "./assets/bus.svg";
import { ReactComponent as MeetAndGreetSvg } from "./assets/meet-and-greet.svg";
import { ReactComponent as WalkSvg } from "./assets/walk.svg";
import type { ParkingTransferType } from "@mozioinc/query";

type AirportTransferIconProps = {
  type: ParkingTransferType;
  className?: string;
};

const transferIconMap = {
  [PARKING_TRANSFER_TYPE.WALK]: WalkSvg,
  [PARKING_TRANSFER_TYPE.SHUTTLE]: BusSvg,
  [PARKING_TRANSFER_TYPE.MEET_AND_GREET]: MeetAndGreetSvg,
};

export const AirportTransferIcon = ({
  type,
  className,
}: AirportTransferIconProps) => {
  const Icon = transferIconMap[type];
  return <Icon className={className} />;
};
